const ActionTypes = {

  // persistence
  SERVER_UPDATE     : "SERVER_UPDATE",
  SAVING            : "SAVING",
  SAVING_DONE       : "SAVING_DONE",
  SAVING_FAILED     : "SAVING_FAILED",
  ENABLE_AUTOSAVE   : "ENABLE_AUTOSAVE", 
  DISABLE_AUTOSAVE  : "DISABLE_AUTOSAVE", 
  DIRTY_PERSISTENCE : "DIRTY_PERSISTENCE", 

  // activities
  CREATE_ONE_ACTIVITIES   : "CREATE_ONE_ACTIVITIES",
  FETCHING_ALL_ACTIVITIES : "FETCHING_ALL_ACTIVITIES",
  RECEIVE_ALL_ACTIVITIES  : "RECEIVE_ALL_ACTIVITIES",
  RECEIVE_ONE_ACTIVITIES  : "RECEIVE_ONE_ACTIVITIES",
  UPDATE_ONE_ACTIVITIES   : "UPDATE_ONE_ACTIVITIES",
  UPDATE_MANY_ACTIVITIES  : "UPDATE_MANY_ACTIVITIES",
  REMOVE_ONE_ACTIVITIES   : "REMOVE_ONE_ACTIVITIES",

  // suppliers
  CREATE_ONE_SUPPLIERS   : "CREATE_ONE_SUPPLIERS",
  FETCHING_ALL_SUPPLIERS : "FETCHING_ALL_SUPPLIERS",
  RECEIVE_ALL_SUPPLIERS  : "RECEIVE_ALL_SUPPLIERS",
  RECEIVE_ONE_SUPPLIERS  : "RECEIVE_ONE_SUPPLIERS",
  UPDATE_ONE_SUPPLIERS   : "UPDATE_ONE_SUPPLIERS",
  UPDATE_MANY_SUPPLIERS  : "UPDATE_MANY_SUPPLIERS",
  REMOVE_ONE_SUPPLIERS   : "REMOVE_ONE_SUPPLIERS",

  // blocks
  CREATE_ONE_BLOCKS   : "CREATE_ONE_BLOCKS",
  FETCHING_ALL_BLOCKS : "FETCHING_ALL_BLOCKS",
  RECEIVE_ALL_BLOCKS  : "RECEIVE_ALL_BLOCKS",
  RECEIVE_ONE_BLOCKS  : "RECEIVE_ONE_BLOCKS",
  UPDATE_ONE_BLOCKS   : "UPDATE_ONE_BLOCKS",
  UPDATE_MANY_BLOCKS  : "UPDATE_MANY_BLOCKS",
  REMOVE_ONE_BLOCKS   : "REMOVE_ONE_BLOCKS",

  // trips
  CREATE_ONE_TRIPS    : "CREATE_ONE_TRIPS",
  FETCHING_ALL_TRIPS  : "FETCHING_ALL_TRIPS",
  RECEIVE_ALL_TRIPS   : "RECEIVE_ALL_TRIPS",
  RECEIVE_ONE_TRIPS   : "RECEIVE_ONE_TRIPS",
  UPDATE_ONE_TRIPS    : "UPDATE_ONE_TRIPS",
  UPDATE_MANY_TRIPS   : "UPDATE_MANY_TRIPS",
  REMOVE_ONE_TRIPS    : "REMOVE_ONE_TRIPS",
  UPDATE_TRIP_NOTES   : "UPDATE_TRIP_NOTES",
  UPDATE_TRIP_CONTENT : "UPDATE_TRIP_CONTENT",

  // ROUTES
  CREATE_ONE_ROUTES   : "CREATE_ONE_ROUTES",
  FETCHING_ALL_ROUTES : "FETCHING_ALL_ROUTES",
  RECEIVE_ALL_ROUTES  : "RECEIVE_ALL_ROUTES",
  RECEIVE_ONE_ROUTES  : "RECEIVE_ONE_ROUTES",
  UPDATE_ONE_ROUTES   : "UPDATE_ONE_ROUTES",
  UPDATE_MANY_ROUTES  : "UPDATE_MANY_ROUTES",
  REMOVE_ONE_ROUTES   : "REMOVE_ONE_ROUTES",
  
  // CITIES
  CREATE_ONE_CITIES   : "CREATE_ONE_CITIES",
  FETCHING_ALL_CITIES : "FETCHING_ALL_CITIES",
  RECEIVE_ALL_CITIES  : "RECEIVE_ALL_CITIES",
  RECEIVE_ONE_CITIES  : "RECEIVE_ONE_CITIES",
  UPDATE_ONE_CITIES   : "UPDATE_ONE_CITIES",
  UPDATE_MANY_CITIES  : "UPDATE_MANY_CITIES",
  REMOVE_ONE_CITIES   : "REMOVE_ONE_CITIES",

  // EXPENSES
  CREATE_ONE_EXPENSES   : "CREATE_ONE_EXPENSES",
  FETCHING_ALL_EXPENSES : "FETCHING_ALL_EXPENSES",
  RECEIVE_ALL_EXPENSES  : "RECEIVE_ALL_EXPENSES",
  RECEIVE_ONE_EXPENSES  : "RECEIVE_ONE_EXPENSES",
  UPDATE_ONE_EXPENSES   : "UPDATE_ONE_EXPENSES",
  UPDATE_MANY_EXPENSES  : "UPDATE_MANY_EXPENSES",
  REMOVE_ONE_EXPENSES   : "REMOVE_ONE_EXPENSES",
  
  // RESERVATIONS
  CREATE_ONE_RESERVATIONS   : "CREATE_ONE_RESERVATIONS",
  FETCHING_ALL_RESERVATIONS : "FETCHING_ALL_RESERVATIONS",
  RECEIVE_ALL_RESERVATIONS  : "RECEIVE_ALL_RESERVATIONS",
  RECEIVE_ONE_RESERVATIONS  : "RECEIVE_ONE_RESERVATIONS",
  UPDATE_ONE_RESERVATIONS   : "UPDATE_ONE_RESERVATIONS",
  UPDATE_MANY_RESERVATIONS  : "UPDATE_MANY_RESERVATIONS",
  REMOVE_ONE_RESERVATIONS   : "REMOVE_ONE_RESERVATIONS",

  // TASKS
  CREATE_ONE_TASKS   : "CREATE_ONE_TASKS",
  FETCHING_ALL_TASKS : "FETCHING_ALL_TASKS",
  RECEIVE_ALL_TASKS  : "RECEIVE_ALL_TASKS",
  RECEIVE_ONE_TASKS  : "RECEIVE_ONE_TASKS",
  UPDATE_ONE_TASKS   : "UPDATE_ONE_TASKS",
  UPDATE_MANY_TASKS  : "UPDATE_MANY_TASKS",
  REMOVE_ONE_TASKS   : "REMOVE_ONE_TASKS",
  INITIATE_PLAN      : "INITIATE_PLAN",
  STOP_PLAN          : "STOP_PLAN",

  // APPDOCS
  CREATE_ONE_APPDOCS   : "CREATE_ONE_APPDOCS",
  FETCHING_ALL_APPDOCS : "FETCHING_ALL_APPDOCS",
  RECEIVE_ALL_APPDOCS  : "RECEIVE_ALL_APPDOCS",
  RECEIVE_ONE_APPDOCS  : "RECEIVE_ONE_APPDOCS",
  UPDATE_ONE_APPDOCS   : "UPDATE_ONE_APPDOCS",
  UPDATE_MANY_APPDOCS  : "UPDATE_MANY_APPDOCS",
  REMOVE_ONE_APPDOCS   : "REMOVE_ONE_APPDOCS",

  // USERS
  FETCHING_ALL_USERS : "FETCHING_ALL_USERS", 
  RECEIVE_ALL_USERS  : "RECEIVE_ALL_USERS", 
  
  // These are used after updating an object through actions other than UPDATE_SHIT
  // persistence reducer looks for these.
  // they are kind of a hack, i know
  UPDATED_ONE_BLOCKS     : "UPDATED_ONE_BLOCKS",
  UPDATED_ONE_TRIPS      : "UPDATED_ONE_TRIPS",
  UPDATED_ONE_ACTIVITIES : "UPDATED_ONE_ACTIVITIES",
  UPDATED_ONE_ROUTES     : "UPDATED_ONE_ROUTES",
  UPDATED_ONE_CITIES     : "UPDATED_ONE_CITIES",

  // UI 
  PLAN_TRIGGER_REJECTED : "PLAN_TRIGGER_REJECTED", 
  PLAN_STOP_HANDLED     : "PLAN_STOP_HANDLED", 
  CHANGE_LANGUAGE       : "CHANGE_LANGUAGE", 
  ADD_PROMPT            : "ADD_PROMPT", 
  CLOSE_FIRST_PROMPT    : "CLOSE_FIRST_PROMPT", 
  TOGGLE_MODAL          : "TOGGLE_MODAL", 

  // Permissions
  GET_PERMISSIONS: "GET_PERMISSIONS"
  
}

export default ActionTypes

